import React, { CSSProperties, FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { NamedLink } from '../../components';
import { FIND_ITEM_METHOD_TO_TAB, ListingPageParamTab } from './EditListingPage.utils';
import { EditListingPageState } from './EditListingPage.duck';
import { useOwnListingVersions } from './hooks/useOwnListingVersions';
import { FindItemMethod } from '../../types/sharetribe/listing';

interface BackToPreviousTabLinkProps {
  children?: ReactNode;
  style?: CSSProperties;
}

const BackToPreviousTabLink: FC<BackToPreviousTabLinkProps> = (props) => {
  const { children, style } = props;
  const { params } = useSelector<any>((state) => state.EditListingPage) as EditListingPageState;
  const { currentListing } = useOwnListingVersions();
  const { publicData } = currentListing.attributes;
  const { findItemMethod } = publicData;

  const previousTab = findItemMethod
    ? FIND_ITEM_METHOD_TO_TAB[findItemMethod as FindItemMethod]
    : ListingPageParamTab.Search;

  if (!params) {
    return null;
  }

  return (
    <NamedLink name="EditListingPage" params={{ ...params, tab: previousTab }} style={style}>
      {children}
    </NamedLink>
  );
};

export default BackToPreviousTabLink;
